import { useContext, useState } from "react";
import styles from "./Accordion.module.css";
import ThemeContext from "config/context/themeContext";

const Accordion = ({
  children,
  header,
  isOpen: initIsOpen = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(initIsOpen);
  const { dark: isDark } = useContext(ThemeContext);

  return (
    <div className={`${styles.accordion} ${isDark ? styles.dark : ""}`}>
      <div
        className={`row justify-space-between align-center ${styles.accordionHeader}`}
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        {header}
        <svg height="16px" width="16px" viewBox="0 0 100 100">
          <path
            d={`M 0 50 H 100 ${!isOpen ? "M 50 0 V 100" : ""}`}
            strokeWidth="10"
          />
        </svg>
      </div>
      {isOpen && (
        <div className={`column ${styles.accordionContent}`}>{children}</div>
      )}
    </div>
  );
};

export default Accordion;
